var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle2, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystalsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 189,
    viewBox: "0 0 194 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94.5,
    r: 92,
    fill: "#2D3344",
    stroke: "#22C55E",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.136 41.4914L150.051 40.2121C149.068 39.1838 147.705 38.6021 146.28 38.6021H118.698C117.273 38.6021 115.91 39.1838 114.927 40.2121V41.4914L122.052 53.1735H144.063L150.136 41.4914Z",
    fill: "#FACC15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.698 38.6021C117.273 38.6021 115.91 39.1838 114.927 40.2121V41.4914L118.508 47.3637L124.679 38.6021H118.698Z",
    fill: "#FACC15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.489 38.6021L122.577 53.1735L123.195 53.7734H141.402L142.401 53.1735L132.489 38.6021Z",
    fill: "#FACC15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.927 40.2124L105.025 50.5684C104.353 51.2709 103.979 52.2037 103.979 53.1738L104.634 53.7734H121.543L122.576 53.1738L114.927 40.2124Z",
    fill: "#FACC15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.417 53.1733L118.856 46.8696L114.927 40.2119L105.025 50.568C104.353 51.2704 103.979 52.2033 103.979 53.1733L104.634 53.7729H114.729L114.417 53.1733Z",
    fill: "#FACC15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161 53.1733C161 52.2033 160.625 51.2704 159.953 50.568L150.051 40.2119L142.401 53.1733L143.162 53.7729H160.5L161 53.1733Z",
    fill: "#FACC15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.979 53.1733C103.979 54.2621 104.368 55.3154 105.078 56.1434L128.425 83.4007C129.441 84.5857 130.926 85.268 132.489 85.268C134.053 85.268 135.538 84.5857 136.553 83.4007L159.901 56.1434C160.61 55.3151 161 54.2621 161 53.1733H103.979Z",
    fill: "#FACC15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.417 53.1733H103.979C103.979 54.2621 104.368 55.3154 105.078 56.1434L128.426 83.4007C129.115 84.2057 130.022 84.7778 131.022 85.0627L114.417 53.1733Z",
    fill: "#FACC15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.49 85.2683C132.991 85.2683 133.484 85.1973 133.957 85.0627L142.402 53.1733H122.577L131.022 85.0627C131.495 85.1973 131.988 85.2683 132.49 85.2683Z",
    fill: "#FACC15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.715 66.313L100.967 64.1213C98.7701 62.7859 96.1202 62.4058 93.6347 63.0693L45.5318 75.9124C43.046 76.576 40.942 78.2254 39.71 80.4764L40.31 82.7078L58.215 99.7634L96.6023 89.5142L101.715 66.313Z",
    fill: "#FACC15"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5318 75.9129C43.046 76.5764 40.942 78.2258 39.71 80.4769L40.31 82.7082L49.3104 91.2815L55.9624 73.1279L45.5318 75.9129Z",
    fill: "#FACC15"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5833 69.4912L59.1299 99.5194L60.4888 100.278L92.2422 91.7998L93.7039 90.2884L69.5833 69.4912Z",
    fill: "#FACC15"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7095 80.4761L27.2969 103.148C26.455 104.686 26.2392 106.487 26.6942 108.179L28.1182 108.919L57.6092 101.046L59.1297 99.5185L39.7095 80.4761Z",
    fill: "#FACC15"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8991 103.318L49.6849 90.2578L39.7095 80.4766L27.2969 103.148C26.455 104.686 26.2392 106.487 26.6942 108.179L28.1182 108.92L45.7252 104.219L44.8991 103.318Z",
    fill: "#FACC15"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.139 81.6276C125.684 79.9358 124.593 78.4837 123.092 77.5713L100.966 64.1211L93.7031 90.2877L95.3107 90.9796L125.548 82.9064L126.139 81.6276Z",
    fill: "#FACC15"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6934 108.179C27.2039 110.078 28.3777 111.733 30.0031 112.847L83.5049 149.512C85.831 151.106 88.7408 151.605 91.4674 150.877C94.1942 150.149 96.4642 148.267 97.6786 145.728L125.614 87.3194C126.463 85.5446 126.649 83.5265 126.138 81.6274L26.6934 108.179Z",
    fill: "#FACC15"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8983 103.319L26.6934 108.179C27.2039 110.078 28.3777 111.733 30.0031 112.848L83.5049 149.513C85.0848 150.595 86.934 151.171 88.8124 151.202L44.8983 103.319Z",
    fill: "#FACC15"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4686 150.877C92.3433 150.644 93.1703 150.29 93.9311 149.836L93.7039 90.2881L59.1299 99.5193L88.8134 151.202C89.7003 151.217 90.5937 151.111 91.4686 150.877Z",
    fill: "#FACC15"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.387 43.2944L147.314 42.1948C146.469 41.311 145.298 40.811 144.073 40.811H120.366C119.141 40.811 117.97 41.311 117.125 42.1948V43.2944L123.249 53.335H142.167L147.387 43.2944Z",
    fill: "#C3DDFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.366 40.8105C119.141 40.8105 117.97 41.3105 117.125 42.1943V43.2939L120.203 48.3411L125.507 40.8105H120.366Z",
    fill: "#A4CCFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.22 40.8105L123.7 53.3345L124.231 53.8501H139.88L140.739 53.3345L132.22 40.8105Z",
    fill: "#DBEAFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.125 42.1948L108.614 51.0957C108.037 51.6995 107.715 52.5012 107.715 53.335L108.278 53.8503H122.812L123.7 53.335L117.125 42.1948Z",
    fill: "#DBEAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.687 53.3345L120.502 47.9165L117.125 42.1943L108.614 51.0952C108.037 51.699 107.715 52.5007 107.715 53.3345L108.278 53.8499H116.955L116.687 53.3345Z",
    fill: "#C3DDFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M156.723 53.3345C156.723 52.5007 156.401 51.699 155.824 51.0952L147.313 42.1943L140.738 53.3345L141.392 53.8499H156.294L156.723 53.3345Z",
    fill: "#DBEAFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.715 53.3345C107.715 54.2703 108.05 55.1755 108.66 55.8872L128.727 79.3145C129.599 80.333 130.875 80.9194 132.219 80.9194C133.563 80.9194 134.84 80.333 135.712 79.3145L155.779 55.8872C156.389 55.1753 156.724 54.2703 156.724 53.3345H107.715Z",
    fill: "#A4CCFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M116.687 53.3345H107.715C107.715 54.2703 108.05 55.1755 108.66 55.8872L128.727 79.3144C129.319 80.0063 130.099 80.498 130.958 80.7429L116.687 53.3345Z",
    fill: "#8BB3EA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.22 80.9197C132.651 80.9197 133.075 80.8586 133.481 80.7429L140.739 53.3345H123.7L130.958 80.7429C131.365 80.8586 131.789 80.9197 132.22 80.9197Z",
    fill: "#C3DDFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2799 70.476L98.6039 68.4956C96.6188 67.2888 94.2243 66.9453 91.9783 67.5449L48.5099 79.1506C46.2637 79.7502 44.3624 81.2407 43.249 83.2749L43.7912 85.2912L59.9712 100.704L94.6599 91.4419L99.2799 70.476Z",
    fill: "#C3DDFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5099 79.1509C46.2637 79.7505 44.3624 81.241 43.249 83.2751L43.7912 85.2915L51.9245 93.0388L57.9356 76.6343L48.5099 79.1509Z",
    fill: "#A4CCFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2441 73.3477L60.7979 100.483L62.0259 101.168L90.7198 93.5068L92.0407 92.1411L70.2441 73.3477Z",
    fill: "#DBEAFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2485 83.2749L32.0318 103.762C31.271 105.152 31.076 106.78 31.4871 108.308L32.7739 108.978L59.4235 101.863L60.7976 100.483L43.2485 83.2749Z",
    fill: "#DBEAFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.938 103.916L52.2628 92.1138L43.2485 83.2749L32.0318 103.762C31.271 105.152 31.076 106.78 31.4871 108.308L32.7739 108.978L48.6846 104.73L47.938 103.916Z",
    fill: "#C3DDFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121.351 84.3154C120.939 82.7866 119.954 81.4744 118.598 80.6499L98.6032 68.4956L92.04 92.1411L93.4927 92.7664L120.817 85.4709L121.351 84.3154Z",
    fill: "#DBEAFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4863 108.308C31.9477 110.024 33.0084 111.52 34.4772 112.527L82.8242 145.659C84.9262 147.1 87.5557 147.55 90.0195 146.892C92.4836 146.234 94.5349 144.534 95.6323 142.24L120.876 89.4585C121.644 87.8547 121.811 86.031 121.35 84.3149L31.4863 108.308Z",
    fill: "#A4CCFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9373 103.917L31.4863 108.309C31.9477 110.024 33.0084 111.52 34.4772 112.527L82.8242 145.66C84.2519 146.638 85.9229 147.158 87.6203 147.186L47.9373 103.917Z",
    fill: "#8BB3EA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0208 146.893C90.8112 146.682 91.5585 146.362 92.246 145.951L92.0407 92.1411L60.7979 100.483L87.6214 147.186C88.4229 147.199 89.2302 147.104 90.0208 146.893Z",
    fill: "#C3DDFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 156.5,
    r: 26,
    fill: "#22C55E",
    stroke: "#2D3344",
    strokeWidth: 4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162 163.672L155.414 157.086L152.586 159.914L162 169.328L181.414 149.914L178.586 147.086L162 163.672Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalsSuccess);
export default __webpack_public_path__ + "static/media/crystals_success.b6c02b46ac4e9642073af42db7dfd528.svg";
export { ForwardRef as ReactComponent };